import { print } from 'graphql'
import { Product } from 'shopify-types'

import { cachedStorefrontClient } from '..'
import { GetProductByIdDocument, type GetProductByIdQuery } from '../__generated/storefront'
import { ProductNotFoundError } from '../errors'
import { GlobalRequestOptions } from '../types'
import { mapGQLProductToProduct } from './graphql'

export const fetchProduct =
  (options: GlobalRequestOptions) =>
  async (id: string): Promise<Product> => {
    const response = await cachedStorefrontClient.request<GetProductByIdQuery>(
      print(GetProductByIdDocument),
      {
        variables: {
          id,
          language: options.language,
          country: options.language.toUpperCase() === 'PL' ? 'PL' : 'DE',
        },
      },
    )

    if (!response.data?.product) {
      throw new ProductNotFoundError(id)
    }

    return mapGQLProductToProduct(response.data.product)
  }
